/**
 * An AbortSignal that aborts after `timeoutMs`, for giving up on a fetch.
 *
 * It does the same job as AbortSignal.timeout, which Safari and iOS gained only in version 16.
 * On older devices (iPad Air 2, iPad mini 4 and iPhone 6s/7 cannot upgrade past 15), calling
 * AbortSignal.timeout throws a TypeError before the request is even sent. This version is built
 * from AbortController and setTimeout, which every supported browser has.
 *
 * The timer runs from creation, so the deadline covers both waiting for the response and reading
 * its body. Nothing else aborts the signal, so once a request fails, `signal.aborted` tells the
 * caller the failure was this timeout.
 */
export function timeoutSignal(timeoutMs: number): AbortSignal {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), timeoutMs);
  return controller.signal;
}
